module.exports = __webpack_public_path__ + "static/media/arab08.770e2dfa.wav";